var path = '/pages/exports/views/wrapper.tpl.html';
var html = "<div ui-view=\"export\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/exports/views/wrapper.tpl.html
// module id = 2251
// module chunks = 1